import { Typography } from '@mui/material';
import { Stack, Box } from '@mui/system';

interface ColorProps {
  value: string;
  label?: string;
  selected?: boolean;
  direction?: 'row' | 'column';
  size?: 'small' | 'medium' | 'large';
}

const Color = ({
  value,
  label,
  selected = false,
  direction = 'row',
  size = 'medium',
}: ColorProps) => {
  const colorSize = {
    small: 40,
    medium: 50,
    large: 60,
  };

  if (!value) return null;

  return (
    <Stack
      gap={2}
      direction={direction === 'row' ? 'column' : 'row'}
      alignItems="center"
    >
      <Box
        sx={{
          // padding: 1,
          borderRadius: 3,
          backgroundColor: 'white',
          border: selected ? '2px solid silver' : 'none',
          boxShadow: 'none',
        }}
      >
        <Box
          sx={{
            backgroundColor: value,
            width: colorSize[size],
            height: colorSize[size],
            borderRadius: 2,
          }}
        />
      </Box>
      {label ? <Typography variant="h5">{label}</Typography> : null}
    </Stack>
  );
};

export default Color;
